export const setOrders = (data) => {
    return {
        type: "SET_ORDERS",
        orders: data
    };
};

export const getOrders = () => {
    return {
        type: "GET_ORDERS"
    }
}

export const setOrderNumber = (orderNumber) => {
    return {
        type :"SET_ORDER_NUMBER",
        orderNumber : orderNumber
    }
}

export const getOrderNumber = () => {
    return {
        type :"GET_NUMBER_OF_STAFF_CART",
    }
}

